import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Box, useToast } from '@frontend/legacy-components';

import { setCardDetails, validateCC } from '../data/actions';

export const CreditCardInput = () => {
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();
  const toast = useToast();

  const setCreditCardInfo = useCallback(async () => {
    if (elements && stripe) {
      try {
        dispatch(validateCC.request());
        const cardElement = elements.getElement(CardElement);
        const { error, token } = await stripe.createToken(cardElement);
        if (error) {
          dispatch(validateCC.error());
          dispatch(
            setCardDetails({
              stripeToken: undefined,
              card: undefined,
            }),
          );
          if (error.type !== 'validation_error') {
            console.error('Unexpected error validating credit card', error);
            toast({
              status: 'error',
              title: "Couldn't validate credit card",
              description: 'An unknown error occurred.',
            });
          }
        } else if (token) {
          dispatch(validateCC.success());
          const { id: stripeToken, card } = token;
          dispatch(
            setCardDetails({
              stripeToken,
              card: card ? { brand: card.brand, last4: card.last4 } : undefined,
            }),
          );
        }
      } catch (error) {
        dispatch(validateCC.error());
        console.error('Unexpected error validating credit card', error);
        toast({
          status: 'error',
          title: "Couldn't validate credit card",
          description: 'An unknown error occurred.',
        });
        dispatch(
          setCardDetails({
            stripeToken: undefined,
            card: undefined,
          }),
        );
      }
    }
  }, [elements, stripe, dispatch, toast]);

  return (
    <Box
      as={CardElement}
      padding={1}
      borderRadius="sm"
      background="page.background"
      onBlur={setCreditCardInfo}
    />
  );
};
